import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;

export default function UserAuth() {
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const startSignup = query.get("mode") === "signup";

  const [isLogin, setIsLogin] = useState(!startSignup);

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [invite, setInvite] = useState("");
  const [loading, setLoading] = useState(false);

  const inviteCodeFromUrl = query.get("invite");

  const submit = async () => {
    if (!phone || !password) return toast.error("Fill all fields");

    if (!isLogin && password !== confirm)
      return toast.error("Passwords do not match");

    setLoading(true);

    try {
      const url = isLogin
        ? `${API}/api/webapi/login`
        : `${API}/api/webapi/register`;

      const body = isLogin
        ? { phoneNumber: phone, pwd: password }
        : { phoneNumber: phone, pwd: password, invitecode: invite };

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (!data.status) {
        toast.error(data.message);
        setLoading(false);
        return;
      }

      localStorage.setItem("token", data.value);

      toast.success(isLogin ? "Login successful" : "Registered successfully");

      navigate("/");
    } catch (err) {
      console.log(err);
      toast.error("Server error");
    }

    setLoading(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) navigate("/");
  }, [navigate]);

  useEffect(() => {
  const token = localStorage.getItem("token");
  if (token) navigate("/");

  // ✅ Auto-fill invite code if present in URL
  if (inviteCodeFromUrl) {
    setInvite(inviteCodeFromUrl);
    setIsLogin(false); // ensure signup mode
  }
}, [navigate, inviteCodeFromUrl]);

  return (
    <div className="auth-page d-flex align-items-center justify-content-center">
      <div className="auth-card">
        <h3 className="text-center mb-3">
          {isLogin ? "User Login" : "Create Account"}
        </h3>

        <input
          type="number"
          className="form-control mb-3"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <input
          type="password"
          className="form-control mb-3"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {!isLogin && (
          <input
            type="password"
            className="form-control mb-3"
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        )}

        {!isLogin && (
          <input
            className="form-control mb-3"
            placeholder="Invite Code"
            value={invite}
            onChange={(e) => setInvite(e.target.value)}
          />
        )}

        <button className="btn auth-btn w-100" onClick={submit}>
          {loading ? "Please wait..." : isLogin ? "Login" : "Sign Up"}
        </button>

        <div className="text-center mt-3">
          <small>
            {isLogin ? "Don't have an account?" : "Already have an account?"}
          </small>

          <button
            className="btn btn-link p-0 ms-1"
            onClick={() => setIsLogin(!isLogin)}
          >
            {isLogin ? "Sign Up" : "Login"}
          </button>
        </div>
      </div>
    </div>
  );
}
